/* eslint-disable import/prefer-default-export */
/* eslint-disable no-use-before-define */
/* eslint-disable func-names */
import { openAjaxCart } from '../utilities/add-to-cart';

const VARIANT_ID_DATASET = 'data-variant-id';
const PRODUCT_FORM_ID = 'product-add-to-cart';
const QTY_INPUT_SELECTOR = 'name="quantity"';
const CART_ERROR_ID = 'cart_error';
const QTY_PLUS_ID = 'product-form-qty-plus';
const QTY_MINUS_ID = 'product-form-qty-minus';
const QTY_WRAPPER_SELECTOR = '.product-form-quantity';
const SUBTOTAL_DATASET = 'data-id="product-form-subtotal"';
const VARIANT_SELECT_ID = 'variant-select';
const ADD_TO_CART_BTN_ID = 'add-to-cart-btn';
const BACK_IN_STOCK_BTN_ID = 'BIS_trigger';
const STICKY_ADD_TO_CART_SELECTOR = '.sticky-add-to-cart';
const STICKY_CLASS = 'stick';
const UNSTICKY_CLASS = 'unstick';
const WEBCHAT_SHADOW_ID = 'tdWebchat';

let productForm =
  document.getElementById(PRODUCT_FORM_ID) || document.querySelector("form[action='/cart/add']");

let quantityInput = productForm && productForm.querySelector(`input[${QTY_INPUT_SELECTOR}]`);
let variantInputs = document.querySelectorAll(`input[${VARIANT_ID_DATASET}]`);
let cartErrorNode = document.getElementById(CART_ERROR_ID);
let qtyPlusButton = document.getElementById(QTY_PLUS_ID);
let qtyMinusButton = document.getElementById(QTY_MINUS_ID);
let subtotalNodes = document.querySelectorAll(`[${SUBTOTAL_DATASET}]`);
let qtyWrapper = document.querySelector(QTY_WRAPPER_SELECTOR);
let addToCartBtn = document.getElementById(ADD_TO_CART_BTN_ID);
let backInStockBtn = document.getElementById(BACK_IN_STOCK_BTN_ID);
let productTopEl = document.querySelector('.product__top');
let productBottomEl = document.querySelector('.product__bottom');
let variantSelect = document.getElementById(VARIANT_SELECT_ID);

const toMoney = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });

function initScroll() {
  if (typeof $.fn.slick !== 'function') return;
  $('.cart-holder .cart__body')
    .height(function () {
      return (
        $(window).height() -
        ($('.cart-holder .cart__header').outerHeight(true) +
          $('.cart-holder .cart__textarea').outerHeight(true) +
          $('.cart-holder .cart__subtotal').outerHeight(true) +
          $('.cart-holder .cart__cta').outerHeight(true) +
          110)
      );
    })
    .niceScroll({
      cursorcolor: '#f1c148',
      cursorwidth: '11px',
      cursorborderradius: '10px',
      cursorborder: '1px solid #645531',
      background: '#bbb5b0',
    });
}

function incrementQuantity() {
  if (!quantityInput) return;
  const qty = parseInt(quantityInput.value, 10);
  const newQty = qty + 1;
  // check not max
  const el = getCurrentVariantEl();
  const variantId = el.value;
  const quantityLimit = getQuantityLimit(variantId);
  if (quantityLimit && newQty > quantityLimit) return;
  //
  quantityInput.value = newQty;
  updateTotalByQtyChange(newQty);
}

function decrementQuantity() {
  if (!quantityInput) return;
  const qty = parseInt(quantityInput.value, 10);
  if (qty <= 1) return;
  const newQty = qty - 1;
  const el = getCurrentVariantEl();
  const variantId = el.value;
  const quantityLimit = getQuantityLimit(variantId);
  if (quantityLimit && newQty <= quantityLimit) {
    addToCartBtn.disabled = false;
  }
  quantityInput.value = newQty;

  updateTotalByQtyChange(newQty);
}

function getVariantSelected() {
  const selected = document.querySelector(`input[${VARIANT_ID_DATASET}]:checked`);
  return selected;
}

function getOptionSelected() {
  if (!variantSelect) return;
  const option = variantSelect.selectedOptions[0];
  // eslint-disable-next-line consistent-return
  return option;
}

function getCurrentVariantEl() {
  let selected = getVariantSelected();
  if (!selected) {
    selected = getOptionSelected();
  }
  return selected;
}

function updateTotalByQtyChange(qty) {
  const selected = getCurrentVariantEl();
  if (!selected) return;
  const variantId = selected.value;
  const quantityLimit = getQuantityLimit(variantId);
  if (quantityLimit && parseInt(qty, 10) > quantityLimit) {
    quantityInput.value = quantityLimit;
    addToCartBtn.disabled = false;
    updateTotal(quantityLimit, selected.dataset.price);
    return;
  }

  addToCartBtn.disabled = false;

  updateTotal(qty, selected.dataset.price);
}

function updateTotalByVariantChange(price) {
  if (!quantityInput) return;
  const qty = parseInt(quantityInput.value, 10);
  const currentVariantEl = getCurrentVariantEl();
  const variantId = currentVariantEl.value;
  const quantityLimit = getQuantityLimit(variantId);
  if (qty > quantityLimit) {
    addToCartBtn.disabled = true;
  } else {
    addToCartBtn.disabled = false;
  }
  updateTotal(qty, price);
}

function updateTotal(price, qty) {
  if (subtotalNodes.length === 0) return;
  const unitPrice = parseInt(price, 10) / 100;
  const subtotal = toMoney.format(unitPrice * qty);
  subtotalNodes.forEach((node) => {
    const n = node;
    n.textContent = subtotal;
  });
}

async function addToCart(e) {
  e.preventDefault();
  hideCartError();
  const data = new FormData(this);
  const variantId = data.get('variant-id');
  const payload = {
    id: variantId,
    quantity: data.get('quantity'),
  };

  const quantityLimit = getQuantityLimit(variantId);
  const errMsg = `Cannot add more than ${quantityLimit} to cart`;
  const exceedsQuantity = exceedsVariantQuantityForCart(payload.quantity, quantityLimit);
  if (exceedsQuantity) return displayCartError(errMsg);

  const exceedsRemoteCartQuantity = await verifyRemoteQuantityForCart(
    quantityLimit,
    payload.quantity,
    parseInt(payload.id, 10)
  );
  if (exceedsRemoteCartQuantity === true) return displayCartError(errMsg);

  return postToCart(payload, onCartSuccess(payload.quantity), onCartError);
}

async function getRemoteCartItems() {
  try {
    const res = await fetch('/cart.js');
    const { items } = await res.json();
    return items;
  } catch (error) {
    return null;
  }
}

async function verifyRemoteQuantityForCart(quantityLimit, toAddQuantity, variantId) {
  if (!quantityLimit) return false;
  const items = await getRemoteCartItems();
  if (!items) return true; // TODO: verify this object in empty, fail, existing state
  const variantCartItem = items.find((item) => item.id === variantId);
  // if an item is found and quantity in cart + qty to be added is more than limit
  if (!variantCartItem) return false;
  return exceedsVariantQuantityForCart(variantCartItem.quantity + toAddQuantity, quantityLimit);
}

/**
 * Check the variantId against the quantity limit data added to the DOM
 *
 * Variants with a quantity limit have a data attr of 'quantity-limit'
 */
function getQuantityLimit(variantId) {
  const node = getVariantOptionFromId(variantId);
  if (!node) return NaN;
  return parseInt(node.dataset.quantityLimit, 10);
}

function getVariantOptionFromId(variantId) {
  const node = [...variantInputs].find((nd) => {
    return nd.dataset.variantId === variantId;
  });
  return node;
}

function exceedsVariantQuantityForCart(quantity, quantityLimit) {
  const limit = parseInt(quantityLimit, 10);
  const qty = parseInt(quantity, 10);
  return limit ? limit < qty : false;
}

function onCartSuccess(qty) {
  return (html) => {
    const $html = $(html).find('.ajax-cart');
    openAjaxCart($html[0]);
    initScroll();

    // update counts in mini cart
    const counts = $('.utility-row .cart-info .cart-icon').html();
    const newCounts = parseInt(counts, 10) + parseInt(qty, 10);
    $('.utility-row .cart-info .cart-icon').html(newCounts);
  };
}

function onCartError(message) {
  displayCartError(message);
}

async function postToCart(payload, onSuccess, onError) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      throw new Error('Sorry, we could not add this item to your cart at this time');
    }
    // fetch html now of the cart
    const html = await fetch('/cart').then((r) => r.text());

    onSuccess(html);
  } catch (error) {
    console.error(error);
    onError(error.message);
  }
}

function displayCartError(msg) {
  if (!cartErrorNode) return;
  cartErrorNode.textContent = msg;
  cartErrorNode.classList.remove('hidden');
}

function hideCartError() {
  if (!cartErrorNode) return;
  cartErrorNode.classList.add('hidden');
}

function updateVariantInUrl(id) {
  window.history.replaceState('', '', `?variant=${id}`);
}

function getVariantFromUrl() {
  const searchParams = new URLSearchParams(window.location.search);
  const variant = searchParams.get('variant');
  return variant;
}

function toggleDisableBtn(element, bool) {
  if (!element) return;
  const el = element;
  el.disabled = bool;
}

function addClass(element, className) {
  if (!element) return;
  element.classList.add(className);
}

function removeClass(element, className) {
  if (!element) return;
  element.classList.remove(className);
}

function handleOutOfStockSelection(available) {
  if (available === 'false') {
    subtotalNodes.forEach((node) => {
      addClass(node, 'out-of-stock');
    });
    toggleDisableBtn(quantityInput, true);
    toggleDisableBtn(qtyPlusButton, true);
    toggleDisableBtn(qtyMinusButton, true);
    addClass(qtyWrapper, 'out-of-stock');
    addClass(addToCartBtn, 'hidden');
    removeClass(backInStockBtn, 'hidden');
  } else {
    subtotalNodes.forEach((node) => {
      removeClass(node, 'out-of-stock');
    });
    toggleDisableBtn(quantityInput, false);
    toggleDisableBtn(qtyPlusButton, false);
    toggleDisableBtn(qtyMinusButton, false);
    removeClass(qtyWrapper, 'out-of-stock');
    removeClass(addToCartBtn, 'hidden');
    addClass(backInStockBtn, 'hidden');
  }
}

/**
 * If a variant id is included in the url as a deeplink we need to update the form accordingly on load
 */
export function initForm() {
  const variantId = getVariantFromUrl();
  if (!variantId) return;
  const input = getVariantOptionFromId(variantId);
  if (!input) return;
  const currSelectedInput = getVariantSelected();
  currSelectedInput.checked = false;
  input.checked = true;
  updateTotalByVariantChange(input.dataset.price);
  handleOutOfStockSelection(input.dataset.available);
  updateAvailabilityText(variantId);
  updateQuantity(variantId);
}

let isSticky = false;
function stickyAddToCart() {
  if (!isSticky) return;
  const stickyAddToCartEl = document.querySelector(STICKY_ADD_TO_CART_SELECTOR);
  if (!stickyAddToCartEl) return;
  const { height } = stickyAddToCartEl.getBoundingClientRect();
  stick(stickyAddToCartEl, height);
}

function shouldRunSticky(hasStickyClass, stickyTop) {
  if (hasStickyClass === true) return;
  isSticky = stickyTop > window.innerHeight;
}

const intersectionCallback = (entries) => {
  entries.forEach((entry) => {
    if (isSticky === false) return;
    const stickyAddToCartEl = document.querySelector(STICKY_ADD_TO_CART_SELECTOR);
    if (!stickyAddToCartEl) return;
    const { height } = stickyAddToCartEl.getBoundingClientRect();

    if (entry.boundingClientRect.top < window.innerHeight) {
      if (entry.isIntersecting) {
        unstick(stickyAddToCartEl);
      }
    } else {
      stick(stickyAddToCartEl, height);
    }
  });
};

const resizeCallback = () => {
  const stickyAddToCartEl = document.querySelector(STICKY_ADD_TO_CART_SELECTOR);
  if (!stickyAddToCartEl) return;
  const { top } = stickyAddToCartEl.getBoundingClientRect();
  shouldRunSticky(stickyAddToCartEl.classList.contains(STICKY_CLASS), top);
  stickyAddToCart();
};

const intersectionObserver = new IntersectionObserver(intersectionCallback, {
  threshold: 0,
});

const resizeObserver = new ResizeObserver(resizeCallback);

function initStickyAddToCart() {
  if (productBottomEl) {
    intersectionObserver.observe(productBottomEl);
    resizeObserver.observe(productBottomEl);
  }
}

function stick(element, elHeight) {
  if (element.style.position === 'fixed') return;
  const el = element;
  el.classList.add(STICKY_CLASS);
  el.classList.remove(UNSTICKY_CLASS);
  setBottomPadding(productTopEl, `${elHeight}px`);
  handleWebChatButtonPos('65%');
}

function unstick(element) {
  if (element.style.position === 'relative') return;
  const el = element;
  el.classList.add(UNSTICKY_CLASS);
  el.classList.remove(STICKY_CLASS);
  setBottomPadding(productTopEl, 0);
  handleWebChatButtonPos('20px');
}

function setBottomPadding(element, padding) {
  const el = element;
  el.style.paddingBottom = padding;
}

function handleWebChatButtonPos(buttonBottom) {
  if (window.innerWidth > 1025) return;
  const shadowEl = document.getElementById(WEBCHAT_SHADOW_ID);
  if (!shadowEl) return;
  const { shadowRoot } = shadowEl;
  if (!shadowRoot) return;
  const button = shadowRoot.querySelector('button');
  if (!button) return;
  button.style.bottom = buttonBottom;
}

function updateSmartWishList(variantId) {
  const wishlistNodes = document.querySelectorAll('.smartwishlist');
  wishlistNodes.forEach((node) => {
    const n = node;
    n.dataset.variant = variantId;
  });
}

function setFirstInStockAsActive() {
  try {
    const allVariants = (window.allVariants && window.allVariants.variants) || [];
    // setFirstInStockDesktop(allVariants);
  } catch (error) {
    console.log('Error', error);
  }
}

function getDatasetMatchingVariant(variantId, el, key) {
  const dataStr = el.dataset[key];
  const arr = dataStr && dataStr.split(',');
  if (!arr) return undefined;
  const item = arr.find((delItem) => {
    const id = delItem.split('-')[0];
    return id === variantId.toString();
  });
  const value = item && item.split('-')[1];
  return value;
}

function updateAvailabilityText(variantId) {
  const el = document.querySelector('div[data-estimated-delivery-dates]');
  const span = el && el.querySelector('span');
  if (!el || !span) return;
  const date = getDatasetMatchingVariant(variantId, el, 'estimatedDeliveryDates');
  const text = date ? `* Expected Availability Date: ${date}` : '';
  span.textContent = text;
}

function updateQuantity(variantId) {
  const el = document.querySelector('div[data-quantity-limits]');
  const span = el && el.querySelector('span');
  if (!el || !span) return;
  const limit = getDatasetMatchingVariant(variantId, el, 'quantityLimits');
  const text = limit ? `* Cannot add more than ${limit} to cart` : '';
  span.textContent = text;
}

// function setFirstInStockDesktop(allVariants) {
//   $('.variants_select').each(function (i, _) {
//     const allOptions = Array.prototype.slice.call(this.querySelectorAll('option'));
//     const firstOption = allOptions && allOptions[0];
//     const variantId = firstOption && firstOption.value;
//     if (!variantId) return;
//     const firstVariant = allVariants.find((variant) => {
//       return variant.id.toString() === variantId;
//     });
//     if (!firstVariant) return;
//     // get group
//     const group = allVariants.filter((variant) => {
//       return variant.option1 === firstVariant.option1;
//     });
//     if (group.length === 0) return;

//     const hasSoldOut = group.some((item) => {
//       return !item.available;
//     });
//     if (!hasSoldOut) return;

//     const allSoldOut = group.every((item) => {
//       return !item.available;
//     });
//     if (allSoldOut) return;

//     const availableInGroup = group.filter((item) => item.available);
//     const sortedInGroup = availableInGroup.sort((a, b) => {
//       return a.price - b.price;
//     });

//     const selected = sortedInGroup[0];
//     const optionToSelect = allOptions.find((option) => option.value === selected.id.toString());
//     if (!optionToSelect) return;
//     const index = optionToSelect.index;
//     this.options[index].selected = true;
//     updateSelection(this);
//   });
// }

/**
 * Initialize event listeners for a dynamic form
 */
export function initListeners() {
  productForm =
    document.getElementById(PRODUCT_FORM_ID) || document.querySelector("form[action='/cart/add']");
  quantityInput = productForm && productForm.querySelector(`input[${QTY_INPUT_SELECTOR}]`);
  variantInputs = document.querySelectorAll(`input[${VARIANT_ID_DATASET}]`);
  cartErrorNode = document.getElementById(CART_ERROR_ID);
  qtyPlusButton = document.getElementById(QTY_PLUS_ID);
  qtyMinusButton = document.getElementById(QTY_MINUS_ID);
  subtotalNodes = document.querySelectorAll(`[${SUBTOTAL_DATASET}]`);
  qtyWrapper = document.querySelector(QTY_WRAPPER_SELECTOR);
  addToCartBtn = document.getElementById(ADD_TO_CART_BTN_ID);
  backInStockBtn = document.getElementById(BACK_IN_STOCK_BTN_ID);
  productTopEl = document.querySelector('.product__top');
  productBottomEl = document.querySelector('.product__bottom');
  variantSelect = document.getElementById(VARIANT_SELECT_ID);

  if (productForm) productForm.addEventListener('submit', addToCart);
  if (qtyPlusButton) qtyPlusButton.addEventListener('click', incrementQuantity);
  if (qtyMinusButton) qtyMinusButton.addEventListener('click', decrementQuantity);
  if (quantityInput)
    quantityInput.addEventListener('change', (e) => {
      const qty = e.target.value;
      updateTotalByQtyChange(qty);
    });

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const option = this.options[this.selectedIndex];
      if (!option) return;
      const { price, variantId, available } = option.dataset;
      updateTotalByVariantChange(price);
      updateVariantInUrl(variantId);
      handleOutOfStockSelection(available);
      updateAvailabilityText(variantId);
      updateQuantity(variantId);
    });
  }

  variantInputs.forEach((input) => {
    input.addEventListener('change', (e) => {
      const { price, variantId, available } = e.target.dataset;
      updateTotalByVariantChange(price);
      updateVariantInUrl(variantId);
      handleOutOfStockSelection(available);
      updateAvailabilityText(variantId);
      updateQuantity(variantId);
    });
  });
}

initListeners();
initForm();
initStickyAddToCart();
